import { useState, useEffect, useMemo, useRef, createRef } from 'react'

import Link from 'next/link'
import { ChevronDown } from '../../svgs/Icons'
import ResponsiveImage from '../../common/ResponsiveImage'

interface SlideshowProps {
	block: any
}


const Slideshow = (props: SlideshowProps) => {

	const { block } = props

	const [ index, setIndex ] = useState(0)
	const [ containerPosition, setContainerPosition ] = useState(0)
	const elementsRef = useRef(block.children.map(() => createRef()))

	useEffect(() => {

		if ( elementsRef.current[index].current ) {
			const position = elementsRef.current[index].current.offsetLeft
			setContainerPosition(position)
		}

	}, [index])


	// Check child blocks for images
	const blockWithImage = useMemo(() => {
		return block.children.filter(( child: any ) => child.image && child.image.length > 0)
	}, [block])

	if ( blockWithImage.length === 0 ) {
		return null
	}


	return (
		<section className='slideshow'>
			<div className='slideshow__wrapper'>
				<div className='slideshow__content'>
					<div className='slideshow__inner' style={{
						transform: `translate3d(-${containerPosition}px,0,0)`
					}}>
						<ul className="slideshow__list">
							{blockWithImage.map((child: any, i: number) => {

								const image = child.image && child.image.length > 0 ? child.image[0] : null
								if (image) {
									return (
										<li
											key={child.id}
											ref={elementsRef.current[i]}
											className="slideshow__item"
											onClick={() => {
												setIndex(i)
											}}
										>
											<ResponsiveImage image={image} cleanImplementation={true} />
										</li>
									)
								}

							})}

						</ul>
					</div>
				</div>
				<div className="slideshow__footer">
					<div className="slideshow__footer-inner">
					<button onClick={() => {
						if ( index > 0 ) {
							setIndex(index-1)
						}
					}}>Previous</button>
					<span>{`${index+1} / ${block.children.length}`}</span>
					<button onClick={() => {
						if ( index+1 < block.children.length ) {
							setIndex(index+1)
						}
					}}>Next</button>
				</div>
				</div>
			</div>
		</section>
	)

}

export default Slideshow
